/**
 * max와 비교했을 때의 current 백분률을 계산해서 반환하는 함수입니다.
 * 백분률은 100%를 넘을 수 없습니다.
 * current나 max가 음수값을 가지면 에러가 발생합니다.
 */
export function calcPercent({current, max}: {current: number; max: number}) {
  if (current < 0 || max < 0) {
    throw new Error('calcPercent는 음수를 다룰 수 없습니다.');
  }
  return Math.min(current ? (100 / max) * current : 0, 100);
}
